(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleHover = this.handleHover.bind(this);
      this.handleHoverOut = this.handleHoverOut.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.mainContent = document.querySelector('#MainContent');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      
      document.addEventListener("DOMContentLoaded", (event) => {this.setHeaderHeight();});


      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.mainContent.classList.add('transparent');
        this.header.style.top = this.announcementBar ? '36px' : '0';
        if (this.announcementBar) {
          this.announcementBar.classList.add('shopify-section-header-sticky');
        }        
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      window.addEventListener('scroll', this.handleScroll);
      this.addEventListener('mouseenter', this.handleHover);
      this.addEventListener('mouseleave', this.handleHoverOut);

      this.createObserver();
    }

    setHeaderHeight() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight + announcementBarHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('mouseenter', this.handleHover);
    }
 
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    handleScroll() {
      const isHomePage = window.location.pathname === '/';
      const isScreenWidthCheck = window.screen.width > 1360;
      if (isHomePage) {
        if (window.scrollY > 150 || this.announcementBar === '' ) {
          this.classList.remove('header-wrapper-transparent');
          this.classList.add('header-wrapper');
        } else {
          this.classList.add('header-wrapper-transparent');
          this.classList.remove('header-wrapper');
        }
      }
    }

    handleHover() {
      const isHomePage = window.location.pathname === '/';
      const isScrolled = window.scrollY > 50;

      if (isHomePage && !isScrolled) {
        this.classList.add('header-wrapper');
        this.classList.remove('header-wrapper-transparent');
      }
    }

    handleHoverOut() {
      const isHomePage = window.location.pathname === '/';
      const isScrolled = window.scrollY > 50;

      if (isHomePage && !isScrolled) {
        this.classList.remove('header-wrapper');
        this.classList.add('header-wrapper-transparent');
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.remove('header-sticking');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.announcementBar.classList.add('shopify-section-header-sticky', 'animate');
      this.mainContent.classList.add('transparent');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('header-sticking');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.announcementBar.classList.remove('shopify-section-header-sticky', 'animate');
      this.mainContent.classList.remove('transparent', 'animate');
      this.header.styel.top = auto;
      document.body.classList.remove('header-sticking');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
